// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"bca6e0b2","162":"f3de3255"}[chunkId] + ".css";
};